import { render, staticRenderFns } from "./Percursos.vue?vue&type=template&id=16cb6f6a&scoped=true&"
import script from "./Percursos.js?vue&type=script&lang=js&"
export * from "./Percursos.js?vue&type=script&lang=js&"
import style0 from "./Percursos.vue?vue&type=style&index=0&id=16cb6f6a&lang=scss&scoped=true&"
import style1 from "./Percursos.vue?vue&type=style&index=1&id=16cb6f6a&scoped=true&lang=css&"
import style2 from "./Percursos.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb6f6a",
  null
  
)

export default component.exports